"use client";

import React, { Suspense, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaTrash } from "react-icons/fa";
import Header from "../../../components/header/header";
import TableTemplate from "../../../components/TableTemplate/TableTemplate";
import ServiceAddPopup from "./ServiceAddPopup";
import Pagination from "../../../components/Pagination/Pagination";
import { getAllServices, deleteService } from "../../../components/http";
import ConfirmationModal from "../../../components/PopUps/ConfirmDeleteButton";
import styles from "../../../components/TableTemplate/TableTemplate.module.scss";

const RegularServices = () => {
  const { t } = useTranslation();
  const [services, setServices] = useState([]);
  const [isServicePopupOpen, setIsServicePopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  
  const limit = 10;

  useEffect(() => {
    fetchServices(currentPage);
  }, [currentPage]);

  const fetchServices = async (page) => {
    setIsLoading(true);
    try {
      const offset = (page - 1) * limit;
      const response = await getAllServices(limit, offset);
      setServices(response.data);
      setTotalRecords(response.total_count);
    } catch (error) {
      console.error(t("service.list.errors.fetching"), error);
    }
    setIsLoading(false);
  };

  const handleDeleteService = async (id) => {
    await ConfirmationModal({
      title: t("service.popUp.delete"),
      text: t("service.popUp.deleteConfirm"),
      confirmButtonColor: "#d33",
      confirmButtonText: t("service.popUp.confirmButtonText"),
      cancelButtonText: t("service.popUp.cancelButtonText"),
      cancelButtonColor: "#3085d6",
      onConfirm: async () => {
        try {
          await deleteService(id);
          fetchServices(currentPage);
        } catch (error) {
          console.error(t("service.list.errors.deleting"), error);
        }
      },
      onCancel: () => {},
      successTitle: t("service.popUp.deleted"),
      successText: t("service.popUp.deleteSuccess")
    });
  };

  const headers = [
    t("service.list.name"),
    t("service.list.price"),
    t("service.list.duration"),
  ];

  const renderServiceRow = (service) => {
    return (
      <>
        <div className={styles.cell} data-label={t("service.list.name")}>
          {service.name || t("service.list.notSpecified")}
        </div>
        <div className={styles.cell} data-label={t("service.list.price")}>
          {service.price ? `$${service.price}` : t("service.list.notSpecified")}
        </div>
        <div className={styles.cell} data-label={t("service.list.duration")}>
          {service.duration || t("service.list.notSpecified")}
        </div>
      </>
    );
  };

  return (
    <Suspense fallback={<div>{t("loading")}</div>}>
      <Header
        title={t("service.list.title")}
        onAddClick={() => setIsServicePopupOpen(true)}
        showImportExport={false}
        onImportClick={null}
        onExportClick={null}
      />
      <TableTemplate
        headers={headers}
        data={services}
        renderRow={renderServiceRow}
        title={t("service.list.title")}
        isLoading={isLoading}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalRecords / limit)}
        onPageChange={(page) => setCurrentPage(page)}
      />
      {isServicePopupOpen && (
        <ServiceAddPopup
          open={isServicePopupOpen}
          onClose={() => setIsServicePopupOpen(false)}
          onServiceAdded={() => fetchServices(currentPage)}
        />
      )}
    </Suspense>
  );
};

export default RegularServices;
